export default __webpack_public_path__ + "assets/images/spring-a42b1772.png";